import React, { useCallback } from 'react';

import ConfirmationDialog from '../../common/ConfirmationDialog/ConfirmationDialog';
import ContactSupport from '../../common/Labels/ContactSupportLink';
import Label from '../../common/Labels/Label';

export const KillTaskConfirmationModal = ({
  error = null,
  taskId = null,
  onKillTask = () => {},
  showDialog = false,
  onDialogToggle = () => {},
}) => {
  const onConfirm = useCallback(() => {
    onKillTask(taskId);
    onDialogToggle(false);
  }, [onDialogToggle, onKillTask, taskId])

  return (
    <ConfirmationDialog
      title="Kill Task"
      confirmButtonText="Kill"
      confirmButtonType="danger"
      showDialog={showDialog}
      onDialogToggle={onDialogToggle}
      modalAnimationKey="kill-task-modal"
      onConfirm={onConfirm}
      error={error}
    >
      <div className="w-small-modal p-2 m-1">
        <Label>
          The selected task and associated tasks runs will no longer be available. This may take several seconds to be reflected in the Task List table. Are you sure?
        </Label>
        {
          error && (
            <div className="p-2">
              <Label color="error" size="sm">
                Error while attempting to kill the task. Please try again or <ContactSupport>contact support</ContactSupport> if the issue persists.
              </Label>
            </div>
          )
        }
      </div>
    </ConfirmationDialog>
  )
};

export default KillTaskConfirmationModal;
